<template> 

    <div v-if="progetto && progetto.ID_PROGETTO" class="row" style="height: auto; margin-bottom: 1rem;">
        <div class="col-3 col-md-3 mb-2">
            <img v-if="progetto.ID_PROGETTO > 0 && progetto.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('PROGETTI',progetto.URL_AVATAR)" class="img-fluid squared-circle rounded-0" alt="" width="215" style="max-height: 230px;" />
            <span v-if="progetto.ID_PROGETTO == 0 || progetto.URL_AVATAR == 'placeholder.jpg'">
                <img src="../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
            </span>
        </div>
        <div class="col-9 col-md-9 mb-2">
            <h4 class="text-primary mb-1" style="height: 3.9rem;">
                {{ progetto.TITOLO }}
            </h4>
            <p class="text-dark mb-1">
                <i class="fal fa-code fa-fw me-1"></i><span class="text-light me-1">|</span>
                Codice: {{ progetto.CODICE_PROGETTO }}
            </p>
            <p class="text-dark mb-1">
                <i class="fal fa-calendar fa-fw me-1"></i><span class="text-light me-1">|</span>
                Evento: {{ filters.formatDate(progetto.DATA_EVENTO) }}
            </p>
            <p class="text-dark mb-1">
                <i class="fal fa-euro-sign fa-fw me-1"></i><span class="text-light me-1">|</span>
                Budget: {{ filters.formattaImporto(progetto.BUDGET_PREVISTO) }}
            </p>
        </div>
    </div>

    <!-- Tab Navigation -->
    <div v-if="progetto && progetto.ID_PROGETTO">
        <div class="row bg-light" style="border-top: 1px solid #ccc;">
            <div class="col-12 ps-0 pe-0">
            <div class="navbar navbar-expand-lg bg-light border-bottom py-1">
                <div class="container-fluid">
                    <ul class="nav navbar-nav flex-row flex-fill" role="tablist">
                        <li class="nav-item me-1" role="presentation">
                                <a href="#tab-riepilogo" ref="tabRiepilogo" class="navbar-nav-link navbar-nav-link-icon active rounded" data-bs-toggle="tab" @click="activeTab = 'riepilogo'" aria-selected="true" role="tab">
                                <div class="d-flex align-items-center mx-lg-1">
                                    <i class="ph-info"></i>
                                    <span class="d-none d-lg-inline-block ms-1">Riepilogo</span>
                                </div>
                            </a>
                        </li>
                        <li class="nav-item me-1" role="presentation">
                                <a href="#tab-attivita" ref="tabAttivita" class="navbar-nav-link navbar-nav-link-icon rounded" data-bs-toggle="tab" @click="activeTab = 'attivita'" aria-selected="false" tabindex="-1" role="tab">
                                <div class="d-flex align-items-center mx-lg-1">
                                    <i class="ph-list-checks"></i>
                                    <span class="d-none d-lg-inline-block ms-1">Attività</span>
                                </div>
                            </a>
                        </li>

                            <li class="nav-item ms-auto" role="presentation">
                                <div class="dropdown"> 
                                    <a href="#" class="nav-link text-danger rounded d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                                        <div class="d-flex align-items-center mx-lg-1">
                                            <i class="ph-gear me-1"></i> <span class="d-none d-lg-inline-block">Azioni</span>
                                            <i class="ph-caret-down ms-1 small"></i> 
                                        </div>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-end shadow-sm">
                                        <a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('PROGETTO_MODIFICA')" v-on:click="modificaProgetto()"><i class="fad fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Progetto </a>
                                        <a href="#" class="dropdown-item"><i class="fad fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa scheda </a>
                                        <a href="#" class="dropdown-item"><i class="fad fa-envelope fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia email </a>
                                        <a href="#" class="dropdown-item"><i class="fad fa-paper-plane fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia sms </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <!-- Tab Content -->
    <div class="content content-2">
        <div class="tab-content flex-1 order-2 order-lg-1">

            <!-- Tab Riepilogo -->
            <div class="tab-pane fade active show" id="tab-riepilogo">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0">Riepilogo Progetto</h6>
                    </div>
                    <div class="card-body" style="max-height: calc(100vh - 300px); overflow-y: auto;">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Titolo</label>
                                <p>{{ progetto.TITOLO }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Codice Progetto</label>
                                <p>{{ progetto.CODICE_PROGETTO }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Cliente</label>
                                <p>{{ progetto.CLIENTE }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Account Manager</label>
                                <p>{{ progetto.ACCOUNT }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Data Evento</label>
                                <p>{{ filters.formatDateTime(progetto.DATA_EVENTO) }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Data Creazione</label>
                                <p>{{ progetto.DATA_ADD !== '0000-00-00 00:00:00' ? filters.formatDateTime(progetto.DATA_ADD) : '-' }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Budget Previsto</label>
                                <p>{{ filters.formattaImporto(progetto.BUDGET_PREVISTO) }}</p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-semibold">Fee</label>
                                <p>{{ progetto.FEE }}%</p>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label fw-semibold">Descrizione</label>
                                <p>{{ progetto.DESCRIZIONE || 'Nessuna descrizione' }}</p>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label fw-semibold">Note</label>
                                <p>{{ progetto.NOTE || 'Nessuna nota' }}</p>
                            </div>
                            <div class="col-md-12 mb-3" v-if="progetto.UTENTI_CONDIVISI && progetto.UTENTI_CONDIVISI.length > 0">
                                <label class="form-label fw-semibold">Utenti Condivisi</label>
                                <div class="d-flex flex-wrap gap-2">
                                    <div v-for="utente in progetto.UTENTI_CONDIVISI" :key="utente.ID_UTENTE" class="badge bg-info">
                                        <img v-if="utente.URL_AVATAR"
                                             :src="filters.getImgPath('USERS', utente.URL_AVATAR)"
                                             :alt="utente.USERNAME"
                                             style="width: 20px; height: 20px; border-radius: 50%; margin-right: 5px;">
                                        {{ utente.USERNAME }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="tab-attivita">
                <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cerca Attività..." :tabindex="1" v-model="searchAttivita.TITOLO.VALUE"/>
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0">Attività e Voci del Progetto</h6>
                    </div>
                    <div class="card-body">
                        <div v-if="paginatedList.arr && paginatedList.arr.length > 0">
                            <div v-for="attivita in paginatedList.arr"
                                 :key="attivita.ID_ATTIVITA"
                                 class="mb-3">
                                <TabAttvitaSchedaVisualizzazioneProgetto :attivita="attivita" :filters="filters" @toggle="toggleAttivita" />
                            </div>
                        </div>
                        <div v-else class="text-muted p-2">
                            Nessuna attività disponibile
                        </div>
                    </div>
                </div>
                <Pagine v-model="searchAttivita.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="searchAttivita.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
            </div>

        </div>
    </div>

</template>

<script>

import Pagine from '@/components/utils/Pagine.vue'
import TabAttvitaSchedaVisualizzazioneProgetto from '@/components/utils/TabAttvitaSchedaVisualizzazioneProgetto.vue'

export default {
    name: "SchedaVisualizzazioneProgetto",
    props: ["modulo"],
    components: {
        Pagine,
        TabAttvitaSchedaVisualizzazioneProgetto,
    },
    emits: ['modificaProgetto'],

    data() {
        return {
            filters: global.filters,
            progetto: {},
            activeTab: 'riepilogo',
            arrayAttivita: [],
             
            searchAttivita:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				TITOLO:{TYPE:'TEXT',VALUE:''},
	        },
        }
    },

    methods: {
        openSchedaVisualizzazioneProgetto(progetto) {
            if (!progetto || !progetto.ID_PROGETTO) {
                console.warn('Progetto non valido');
                return;
            }
            utils.ajax("theb/progetto", { ID_PROGETTO: progetto.ID_PROGETTO }, (response) => {
                if (response.esito == 0) {
                    this.progetto = response.data[0];
                    this.getAttivita(progetto.ID_PROGETTO);
                } else {
                    console.warn('Nessun progetto trovato per ID:', progetto.ID_PROGETTO);
                }
            });
        },

        getAttivita(idProgetto) {
            utils.ajax("theb/attivita", { FK_ID_PROGETTO: idProgetto }, (response) => {
                this.arrayAttivita = (response.data || []).map(attivita => this.prepareAttivita(attivita));
            });
        },

        prepareAttivita(attivita) {
            return {
                ...attivita,
                VOCI: attivita.VOCI || [],
                SOTTO_ATTIVITA: (attivita.SOTTO_ATTIVITA || []).map(sotto => this.prepareAttivita(sotto))
            };
        },

        toggleAttivita(attivita) {
            attivita.expanded = !attivita.expanded;
        },

        modificaProgetto() {
            this.$emit("modificaProgetto", this.progetto);
        }
    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayAttivita,this.searchAttivita);
            return arr;
        },
    }
}
</script>